import useStorage from '@internal/hooks/use-storage';

type CountryModalStorageSchema = {
  closed: boolean;
};

export const useCountryModalStorage = () => {
  const storage = useStorage<CountryModalStorageSchema>({
    domainKey: 'country-modal',
    type: 'local',
  });

  return storage;
};
